module.exports = __webpack_public_path__ + "img/weal2.2ac72d18.png";